import React from 'react';
import styled from 'styled-components';

import Section from './global/section';
import Top from './top';
import mdToHtml from '../util/mdToHtml';

const StyledCircleContent = styled.div`
	.flex {
		display: flex;
		.left {
			width: 50%;
			h1 {
				margin-bottom: 1rem;
			}
		}
		.right {
			width: 50%;
			padding-left: 4rem;
			padding-bottom: 2rem;
			display: flex;
			justify-content: center;
			align-items: center;
			img {
				border-radius: 100%;
				width: 100%;
			}
		}
		@media all and (max-width: 868px) {
			flex-direction: column;
			.left,
			.right {
				width: 100%;
				padding-left: 0;
				img {
					max-width: 450px;
					padding: 1rem;
				}
			}
		}
	}
`;

export default ({ data }) => {
	const { title, top, content1, content2, img } = data;
	return (
		<StyledCircleContent>
			<Section bg="white">
				<div className="flex">
					<div className="left">
						<Top color="blue">{top}</Top>
						<h1>{title}</h1>
						<div
							className="md-content"
							dangerouslySetInnerHTML={{
								__html: mdToHtml(content1),
							}}
						/>
					</div>
					<div className="right">
						<img src={img.src} alt={img.alt} />
					</div>
				</div>
				{content2 && (
					<div
						className="md-content"
						dangerouslySetInnerHTML={{
							__html: mdToHtml(content2),
						}}
					/>
				)}
			</Section>
		</StyledCircleContent>
	);
};
